<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="activeDocumentsContainer">
  @if (activeDocsList && activeDocsList.length) {
    <div class="row">
      <div class="col-12">
        <h3
          class="page-title"
          [xdaTranslate]="'SDE_ACTIVE_DOCUMENTS'"
          role="banner"
          [attr.aria-label]="
            'SDE_ACTIVE_DOCUMENTS_MANAGEMENT' | xdaTranslate
          "></h3>
      </div>
    </div>
  }
  @if (activeDocsList && activeDocsList.length) {
    <div
      class="table-responsive show-non-mobile"
      role="region"
      [attr.aria-label]="'SDE_ACTIVE_DOCUMENTS' | xdaTranslate">
      <table class="table table-sort mb-0">
        <thead>
          <tr>
            <th
              sortableCol="fileName"
              direction="asc"
              (sort)="setSortParams($event)"
              scope="col"
              class="sort-active doc-name head">
              <span xdaTranslate>SDE_NAME3</span>
            </th>
            <th
              sortableCol="documentCreated"
              direction="desc"
              [initialSort]="true"
              (sort)="setSortParams($event)"
              scope="col"
              sorttype="date"
              class="doc-created">
              <span xdaTranslate>SDE_CREATED</span>
            </th>
            <th
              sortableCol="documentExpiryDate"
              direction="asc"
              (sort)="setSortParams($event)"
              scope="col"
              sorttype="date"
              class="doc-expires">
              <span xdaTranslate>SDE_EXPIRES1</span>
            </th>
            <th
              sortableCol="documentSecurityLevel"
              direction="asc"
              (sort)="setSortParams($event)"
              scope="col"
              class="doc-security">
              <span xdaTranslate>SDE_SECURITY</span>
            </th>
            <th
              sortableCol="documentStatus"
              direction="asc"
              (sort)="setSortParams($event)"
              scope="col"
              class="doc-status">
              <span xdaTranslate>SDE_STATUS</span>
            </th>
            <th
              scope="col"
              class="doc-action"
              [attr.aria-label]="
                'SDE_ACTIVE_DOCUMENTS_MANAGEMENT' | xdaTranslate
              "></th>
          </tr>
        </thead>
        <tbody>
          @for (
            doc of activeDocsList
              | tableSort: direction : column : type
              | slice: (page - 1) * pageSize : page * pageSize;
            track doc;
            let i = $index;
            let last = $last;
            let first = $first
          ) {
            <tr>
              <td class="doc-name" [attr.aria-label]="$any(doc).fileName">
                <span
                  triggers="hover"
                  [ngbTooltip]="$any(doc).fileName"
                  [disableTooltip]="
                    $any(doc).fileName && $any(doc).fileName.length <= 40
                  ">
                  {{
                    $any(doc).fileName && $any(doc).fileName.length > 40
                      ? ($any(doc).fileName | slice: 0 : 40) + '...'
                      : $any(doc).fileName
                  }}</span
                >
              </td>
              <td class="doc-created">
                <div class="d-flex doc-status-icons">
                  <span class="date-wrapper flex-grow-1">
                    <span
                      class="create-date"
                      [ngClass]="{ 'date-warning': $any(doc).documentDeadSoon }"
                      >{{ $any(doc).documentCreatedFormatted }}</span
                    >
                    <span
                      class="create-time"
                      [ngClass]="{ 'date-warning': $any(doc).documentDeadSoon }"
                      >{{ $any(doc).documentCreatedTimeFormatted }}</span
                    >
                  </span>
                  @if ($any(doc).documentDeadSoon) {
                    <span
                      class="align-self-center dead-soon xgl-alert_alt xglsize-24"
                      [placement]="last && !first ? 'top' : 'bottom'"
                      triggers="hover"
                      [ngbTooltip]="$any(doc).documentKillToolTip"></span>
                  }
                </div>
              </td>
              <td class="doc-expires">
                <div class="d-flex doc-status-icons">
                  <span
                    class="flex-grow-1"
                    [ngClass]="{
                      'date-warning': $any(doc).documentExpiresSoon,
                    }"
                    >{{ $any(doc).documentExpiryDateFormatted }}</span
                  >
                  @if ($any(doc).documentExpiresSoon) {
                    <span
                      class="align-self-center expire-soon xgl-alert_alt xglsize-24"
                      [placement]="last && !first ? 'top' : 'bottom'"
                      triggers="hover"
                      [ngbTooltip]="$any(doc).documentExpiryToolTip"></span>
                  }
                </div>
              </td>
              <td class="doc-security">
                <span xdaTranslate>{{ $any(doc).documentSecurityLevel }}</span>
              </td>
              <td class="doc-status">
                <span xdaTranslate>{{ $any(doc).documentStatus }}</span>
              </td>
              <td class="doc-action">
                <div class="icons d-flex justify-content-end">
                  @if ($any(doc).documentStatus != 'SDE_EXPIRED') {
                    <span
                      class="doc-action-icon doc-icon-expire xgl-calendar_cancel xglsize-24"
                      (click)="expireDoc($any(doc).id)"
                      placement="left"
                      triggers="hover"
                      [ngbTooltip]="
                        'SDE_SET_DOCUMENT_EXPIRE' | xdaTranslate
                      "></span>
                  }
                  <span
                    class="doc-action-icon doc-icon-delete xgl-trash xglsize-24"
                    (click)="deleteDoc($any(doc).id)"
                    placement="left"
                    triggers="hover"
                    [ngbTooltip]="'SDE_DELETE_DOCUMENT2' | xdaTranslate"></span>
                  <span
                    class="doc-action-icon doc-icon-settings xgl-gear xglsize-24"
                    (click)="viewDocDetails($any(doc).id)"
                    placement="left"
                    triggers="hover"
                    [ngbTooltip]="
                      'SDE_VIEW_DOCUMENT_DETAILS' | xdaTranslate
                    "></span>
                </div>
              </td>
            </tr>
          }
          <tr class="no-results">
            <td
              class="text-center"
              colspan="5"
              [xdaTranslate]="'SDE_NO_SEARCH_RESULTS2'"></td>
          </tr>
        </tbody>
      </table>
    </div>
  }
  @if (activeDocsList && activeDocsList.length && displayPagination) {
    <xrx-pagination
      [(page)]="page"
      [(pageSize)]="pageSize"
      [initialPageSize]="initialPageSize"
      [pageSizeList]="pageSizeList"
      [collectionSize]="activeDocsList.length"
      class="d-flex justify-content-center justify-content-sm-end">
    </xrx-pagination>
  }
  @if (noDocuments) {
    <div class="no-documents align-items-center d-flex flex-column">
      <h4
        class="h4 text-center"
        [xdaTranslate]="'SDE_ACTIVE_DOCUMENTS_CREATED'"></h4>
      <picture>
        <source
          media="(max-width: 575px)"
          srcset="images/pathways/Active_Documents_SM.png" />
        <img
          class="img-fluid"
          src="images/pathways/Active_Documents_LG.png"
          [alt]="'SDE_ACTIVE_DOCUMENTS' | xdaTranslate"
          srcset="images/pathways/Active_Documents_LG.png" />
      </picture>
      <div class="text-center" [xdaTranslate]="'SDE_CAN_VIEW_STATUS'"></div>
    </div>
  }
  @if (showUpload) {
    <div>
      <input
        #fileSelect
        type="file"
        accept=".doc,.docx,.pdf,.ppt,.pptx"
        (change)="uploadFile = $event.target.files" />
      <button [disabled]="!uploadFile" (click)="createRPD()">
        Create Document
      </button>
    </div>
  }
</div>
